import React from 'react';
import AppSidebar from './AppSidebar';
import { Navbar } from './Components/Catalyst/navbar';
import { SidebarLayout } from './Components/Catalyst/sidebar-layout';
import { ErrorPage } from './Components/Custom/ErrorPage';

/**
 * A signed-in URL that matches no route (#652). It used to redirect to
 * `/login`, which bounced a signed-in homeowner to `/home` with no word
 * about the link they had followed being wrong.
 */
const NotFoundPage: React.FC = () => (
  <SidebarLayout
    sidebar={<AppSidebar currentPage="not_found" />}
    navbar={<Navbar />}
  >
    <ErrorPage
      title="Page not found"
      message="That link doesn't go anywhere. It may be mistyped, or the page may have moved."
    />
  </SidebarLayout>
);

export default NotFoundPage;
